export const SECTORS = [
  {
    id: "defence",
    name: "Defence Technology",
    tagline: "Sovereign capability, procured with confidence.",
    desc: "Dual-use innovation and sovereign capability programs, positioned for strategic procurement pathways.",
    img: "https://images.unsplash.com/photo-1581001736925-0870df331c54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxkZWZl&w=1600&q=80",
    alt: "Defence radar array and aerospace communication system against a dusk sky",
    focus: [
      "Dual-use technology evaluation and venture diligence",
      "Defence innovation mission and iDEX pathway advisory",
      "Strategic procurement readiness and offset navigation",
      "Export control and compliance posture",
      "Institutional capital for strategic hardware",
    ],
    credentials: [
      { title: "MeitY program evaluation tenure", note: "National deep-tech programs assessed from inside the Government of India." },
      { title: "B2G mission alignment practice", note: "Procurement pathway design for high-sensitivity public mandates." },
    ],
    insight: "b2g-playbook-deep-tech-startups",
  },
  {
    id: "agritech",
    name: "Agritech",
    tagline: "From pilot plots to state-level missions.",
    desc: "Precision agriculture ventures scaled from pilot plots to state-level missions.",
    img: "https://images.unsplash.com/photo-1763830478855-abf9a8a50190?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxhZ3Jp&w=1600&q=80",
    alt: "Precision agriculture machinery operating across farmland",
    focus: [
      "Precision agriculture venture validation",
      "Pilot-to-scale structuring with state agriculture missions",
      "Agri-data platforms with DPDP-grade discipline",
      "Impact investor syndication",
      "Market linkage design for farmer producer ecosystems",
    ],
    credentials: [
      { title: "i-Hub Gujarat MoU", note: "Structured mentorship for agri and rural innovators in the state ecosystem." },
      { title: "Investor network", note: "Impact-aligned syndicates for ventures with measurable rural outcomes." },
    ],
    insight: "mind-to-market-incubation-gaps",
  },
  {
    id: "ai-deeptech",
    name: "AI & Deep-Tech",
    tagline: "Sovereign AI, from policy paragraph to production.",
    desc: "Sovereign AI strategy, model governance and research-to-market translation.",
    img: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxhcnRp&w=1600&q=80",
    alt: "Abstract neural network sphere representing deep-learning computation",
    focus: [
      "Sovereign AI policy positioning",
      "Model governance and evaluation frameworks",
      "IP strategy for AI and compute assets",
      "Compute mission and skilling alignment",
      "Research-to-market translation for labs and startups",
    ],
    credentials: [
      { title: "MTech in AI, IIT Jammu", note: "Research-grade fluency behind every technical diligence call." },
      { title: "MeitY AI program fluency", note: "Direct experience of how national AI missions are framed and funded." },
      { title: "NIELIT skilling collaboration", note: "Digital skilling programs for the AI workforce." },
    ],
    insight: "sovereign-ai-policy-before-technology",
  },
  {
    id: "robotics-iot",
    name: "Robotics & IoT",
    tagline: "From lab bench to industrial deployment.",
    desc: "Connected hardware ventures guided from lab bench to industrial deployment.",
    img: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=1600",
    alt: "Industrial robotic arm automation in a low-light facility",
    focus: [
      "Hardware validation and industrial pilot design",
      "Component and manufacturing ecosystem connects",
      "Telematics and edge data strategy",
      "Standards and certification navigation",
      "Corporate pilot matching with enterprise buyers",
    ],
    credentials: [
      { title: "i-Hub Gujarat MoU", note: "Mind-to-market guidance for hardware founders." },
      { title: "STPI-NEXT ecosystem", note: "Incubation and VC connects inside the MeitY startup apparatus." },
    ],
    insight: "mind-to-market-incubation-gaps",
  },
  {
    id: "smart-cities",
    name: "Smart Cities & ITS",
    tagline: "Urban technology, aligned with the mission.",
    desc: "Urban technology mandates aligned with municipal missions and intelligent transport programs.",
    img: "https://images.unsplash.com/photo-1519501025264-65ba15a82390?auto=format&fit=crop&q=80&w=1600",
    alt: "Illuminated smart-city skyline and transit network at night",
    focus: [
      "Municipal and Smart Cities Mission alignment",
      "Intelligent transport system procurement pathways",
      "PPP and concession structuring",
      "Urban data governance and privacy posture",
      "Command centre and sensor network evaluation",
    ],
    credentials: [
      { title: "MeitY digital infrastructure experience", note: "Program design across the national electronics and IT agenda." },
      { title: "B2G practice", note: "Mission attachment strategy for urban technology vendors." },
    ],
    insight: "b2g-playbook-deep-tech-startups",
  },
  {
    id: "connected-mobility",
    name: "Connected Mobility",
    tagline: "EV and telematics ventures, built for regulators and fleets.",
    desc: "EV, fleet and telematics ventures positioned for regulators and enterprise adoption.",
    img: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&q=80&w=1600",
    alt: "Connected vehicle on an illuminated highway at night",
    focus: [
      "EV ecosystem and charging infrastructure advisory",
      "Fleet telematics and vehicle data compliance",
      "Automotive regulatory navigation",
      "Enterprise fleet sales strategy",
      "Mobility platform positioning and partnerships",
    ],
    credentials: [
      { title: "Investor network", note: "Institutional syndicates and international banks for mobility deals." },
      { title: "Corporate innovation programs", note: "Structured pilots between mobility startups and enterprises." },
    ],
    insight: "b2g-playbook-deep-tech-startups",
  },
  {
    id: "industry-4",
    name: "Industry 4.0 & ML",
    tagline: "Manufacturing intelligence, without the buzzwords.",
    desc: "Manufacturing intelligence programs for enterprises modernising production.",
    img: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&q=80&w=1600",
    alt: "Automated smart-factory facility with digital controls",
    focus: [
      "Manufacturing digitalisation roadmaps",
      "Predictive ML adoption programs",
      "MSME scheme and incentive alignment",
      "Industrial IP protection",
      "Vendor and technology evaluation",
    ],
    credentials: [
      { title: "Corporate innovation programs", note: "Enterprise venture studios that convert pilots into production." },
      { title: "STPI-NEXT connects", note: "Ecosystem access for industrial technology ventures." },
    ],
    insight: "mind-to-market-incubation-gaps",
  },
  {
    id: "fintech",
    name: "Fintech",
    tagline: "Regulated innovation with data discipline built in.",
    desc: "Regulated-finance innovation with DPDP-grade data discipline built in from day one.",
    img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1600",
    alt: "Financial district architecture housing digital transaction infrastructure",
    focus: [
      "Regulatory navigation across financial frameworks",
      "DPDP compliance by design",
      "Institutional capital and banking partnerships",
      "Cross-border remittance and expansion strategy",
      "Fraud and risk analytics posture",
    ],
    credentials: [
      { title: "Investor network", note: "Deal-flow spanning venture funds and international banks." },
      { title: "AI & DPDP skilling practice", note: "Data-protection fluency programs for financial institutions." },
    ],
    insight: "b2g-playbook-deep-tech-startups",
  },
];
